import dsc from '../../Assets/dsc.png';
import ReactNative from '../../Assets/ReactNative.png';
import android from '../../Assets/android.png'
import EW from '../../Assets/ew.jpg'

const data = [
  {
    title: "Software Developer",
    place: "EmployWise",
    date: "February 2023 - Present",
    desc: "Integrating new modules and handling the Android & iOS application",
    img: EW,
    tag: {
      color: '#61dbfb',
      text: "React Native",
    },
  },
  {
    title: "Software Developer Intern",
    place: "EmployWise",
    date: "September 2022 - February 2023",
    desc: "Enhancing the Employwise mobile application",
    img: EW,
    tag: {
      color: '#61dbfb',
      text: "React Native",
    },
  },
  {
    title: "App Developer Intern",
    place: "Grape Town",
    date: "August 2021 - December 2021 ",
    desc: "Creating UGC based mobile application from scratch.",
    img: ReactNative,
    tag: {
      color: '#61dbfb',
      text: "React Native",
    },
  },
  {
    title: "App Developer Intern",
    place: "Pointlocals (OPC) Pvt. Ltd.",
    date: "June 2021 - August 2021",
    desc: "Redesign UI, Integrated APIs and resolved issues",
    img: ReactNative,
    tag: {
      color: '#61dbfb',
      text: "React Native",
    },
  },
  {
    title: "Campus Facilitator",
    place: "Android Study Jams DSC DCE",
    date: "December 2020",
    img: android,
    tag: {
      color: '#4285F4',
      text: "Google DSC",
    },
  },
  {
    title: "Core Team Lead",
    place: "Google DSC",
    date: "October-June 2021",
    img: dsc,
    tag: {
      color: '#4285F4',
      text: "Google DSC",
    },
  },
];

export default data;
